export default {
  C: "C",
  CSharp: "Cis",
  D: "D",
  DFlat: "Des",
  DSharp: "Dis",
  E: "E",
  EFlat: "Es",
  F: "F",
  FSharp: "Fis",
  G: "G",
  GFlat: "Ges",
  GSharp: "Gis",
  A: "A",
  AFlat: "As",
  ASharp: "Ais",
  B: "B",
  BFlat: "Bes",

  correctExcl: "Goed!",
  wrongExcl: "Fout!",

  ABORT: "AFBREKEN",

  lastRound: "Laatste ronde",
  score: "Punten",
  accuracy: "Nauwkeurigheid",
  correct: "correct",
  wrong: "fout",

  START: "START",
  settings: "Instellingen",
  ROUND_LENGTH: "RONDEDUUR",
  NOTE_INPUT: "NOTENINVOER",
  CLEF: "NOTENSLEUTEL",
  DIFFICULTY: "MOEILIJKHEIDSGRAAD",
  ACCIDENTALS: "TEKEN",
  LANGUAGE: "TAAL",
  twentySeconds: "20 s",
  oneMinute: "1 min",
  fiveMinutes: "5 min",
  infinite: "Oneindig",
  buttons: "Knoppen",
  piano: "Piano",
  trebleClef: "Viool",
  bassClef: "Bass",
  altoClef: "Alt",
  tenorClef: "Tenor",
  easy: "Makkelijk",
  normal: "Normaal",
  hard: "Moeilijk",
  none: "Geen",
  sharp: "♯",
  flat: "♭",
  sharpAndFlat: "♯ en ♭",
  SOUND: "GELUID",
  VIBRATION: "VIBRATIE",
  DISPLAYCORRECTNOTE: "JUISTE MUZIEKNOOT WEERGEVEN",
  on: "Aan",
  off: "Uit",

  TIME: "TIJD",
  CORRECT: "CORRECT",
  ACCURACY: "NAUWKEURIGHEID",
  SCORE: "PUNTEN",

  record: "Record"
};



// WEBPACK FOOTER //
// ./src/resources/nl.js